import React from 'react';

const InstitutionalButton = () => {
    return (
        <div className="w-full mt-4 mb-16 animate-fade-in px-4">
            <a
                href="https://calz.org.ar"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative flex flex-col items-center justify-center w-full py-8 md:py-10 bg-white border-2 border-slate-200 rounded-[2.5rem] overflow-hidden transition-all duration-500 hover:border-primary-400 hover:shadow-2xl hover:-translate-y-2"
            >
                {/* Animated Background Gradient */}
                <div className="absolute inset-0 bg-gradient-to-r from-primary-50 via-white to-primary-50 opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>

                {/* Inner Glow Effect */}
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary-300 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>

                <div className="relative z-10 flex flex-col items-center gap-2">
                    <span className="text-primary-600 font-extrabold text-[10px] md:text-xs uppercase tracking-[0.4em] mb-1 opacity-70 group-hover:opacity-100 group-hover:tracking-[0.5em] transition-all duration-500">
                        Explorá más contenidos
                    </span>
                    <h3 className="text-2xl md:text-4xl font-black text-slate-800 group-hover:text-primary-900 transition-colors duration-300 flex items-center gap-4">
                        Navegar el sitio institucional del CALZ
                        <div className="p-2 bg-slate-50 rounded-full group-hover:bg-primary-100 group-hover:rotate-45 transition-all duration-500 shadow-sm border border-slate-100">
                            <svg className="w-6 h-6 md:w-8 md:h-8 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                        </div>
                    </h3>
                </div>

                {/* Subtle Decorative Elements */}
                <div className="absolute bottom-0 right-0 w-32 h-32 bg-primary-100/20 rounded-full -mr-16 -mb-16 blur-2xl group-hover:bg-primary-200/40 transition-colors duration-500"></div>
                <div className="absolute top-0 left-0 w-24 h-24 bg-blue-100/20 rounded-full -ml-12 -mt-12 blur-2xl group-hover:bg-blue-200/30 transition-colors duration-500"></div>
            </a>
        </div>
    );
};

export default InstitutionalButton;
